import { OnChanges } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormUtilities } from '../utilities/form-utilities';
import { ConvenienceFeeService } from '../../services/convenience-fee/convenience-fee.service';
export class TransactionForms {
  /** Dynnamic Receipt Form Fields*/
  static Request: FormlyFieldConfig[] = [
    //not readonly because they need to be modified, at times
    {
      // Request Type / Area determines who must approve this funds request.
      // Options are the organization's active FundsRequestTypes, loaded by the
      // host component. The server is authoritative for approval routing — only
      // the selected type id is submitted.
      key: 'fundsRequestTypeId',
      type: 'select',
      props: {
        label: 'Request Type / Area',
        placeholder: 'Select a request type...',
        options: [],
        valueProp: 'id',
        labelProp: 'name',
        required: true,
        description: 'Determines who approves this request',
      },
    },
    {
      key: 'payee',
      type: 'input',
      props: {
        label: 'Payee Name',
        placeholder: 'payee',
        required: true,
        description: 'Check should be written to...',
      },
    },
    {
      key: 'title',
      type: 'input',
      props: {
        label: 'Title',
        placeholder: 'title or description',
        required: true,
        description: 'describe request payment',
      },
    },
    {
      key: 'amount',
      type: 'input',
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Amount',
        placeholder: 'amount of transaction',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: true,
      },
    },
    {
      key: 'note',
      type: 'textarea',
      props: {
        label: 'Notes',
        placeholder: 'Add payment request notes here',
        rows: 10,
        required: false,
      },
    },
  ];

  /** Dynamic Transaction Form Fields*/
  static Transaction: FormlyFieldConfig[] = [
    {
      key: 'title',
      type: 'input',
      props: {
        label: 'Title',
        placeholder: 'description',
        required: true,
      },
    },
    {
      key: 'transactionDate',
      type: 'datepicker',
      defaultValue: new Date(),

      props: {
        maxDate: new Date().setHours(23, 59, 59, 999),
        max: new Date().setHours(23, 59, 59, 999),
        label: 'Transaction Date',
        placeholder: 'mm-dd-yyyy',
        required: true,
      },
    },
    {
      key: 'budgetDate',
      type: 'datepicker',
      props: {
        label: 'Budget Date (Optional)',
        placeholder: 'mm-dd-yyyy',
        required: false,
        description: 'Override when this transaction counts in budget actuals. Leave blank to use the transaction date.',
      },
    },
    {
      key: 'amount',
      type: 'input',
      // hideExpression: 'model.hasInstallments',
      expressions: {
        hide: 'model.hasInstallments',
      },
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Amount',
        placeholder: 'amount of transaction',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: true,
      },
    },
    {
      key: 'creditId',
      type: 'tags',
      // hideExpression: `(model.amount === 0 || (!['deposit', 'invoice', 'receipt', 'Invoice'].includes(model.transactionType))) `,
      expressions: {
        hide: `(model.amount === 0 || (!['deposit', 'invoice', 'receipt', 'Invoice'].includes(model.transactionType))) `,
      },
      props: {
        label: 'Account',
        placeholder: 'account to credit',
        valueProp: 'id',
        labelProp: 'label',
        options: [],
        required: false,
        singleSelection: true,
      },
    },
    {
      key: 'debitId',
      type: 'tags',
      // hideExpression: `(model.amount === 0 || (!['check_requisition', 'expense', 'transaction'].includes(model.transactionType)))`,
      expressions: {
        hide: `(model.amount === 0 || (!['check_requisition', 'expense', 'transaction'].includes(model.transactionType)))`,
      },
      props: {
        label: 'Account',
        placeholder: 'account to debit',
        valueProp: 'id',
        labelProp: 'label',
        options: [],
        required: false,
        singleSelection: true,
      },
    },
    {
      key: 'budget',
      type: 'tags',
      // hideExpression: '(model.amount === 0 || model.creditId)',
      expressions: {
        hide: '(model.amount === 0 || ["Cancelled", "Deleted", "Reversed", "Denied"].includes(model.status))',
      },
      props: {
        label: 'Budget Category',
        placeholder: 'budget category',
        valueProp: 'id',
        labelProp: 'item',
        options: [],
        required: false,
        singleSelection: true,
      },
    },
    {
      key: 'note',
      type: 'textarea',
      props: {
        label: 'Notes',
        placeholder: 'Add notes to display to payee here',
        rows: 10,
        required: false,
      },
    },
  ];

  /** Dynamic Invoice Fields*/
  static Invoice: FormlyFieldConfig[] = [
    {
      key: 'title',
      type: 'input',
      props: {
        label: 'Title',
        placeholder: 'description',
        required: true,
      },
    },
    {
      key: 'memberId', //Change to AutoComplete
      type: 'autocomplete',
      props: {
        label: 'Select Member',
        placeholer: 'search for member',
        options: [
          { value: 'Item 1', label: 'Item 1' },
          { value: 'Item 2', label: 'Item 2' },
        ],
        required: true,
        description: 'sends electronic invoice to the selected individual',
      },
    },
    {
      key: 'hasInstallments',
      type: 'toggle',
      defaultValue: false,
      props: {
        // addonLeft: {
        //     class: 'icon-wallet',
        // },
        label: 'Installments?',
        // required: true
      },
    },
    {
      key: 'invoice',
      type: 'tags',
      expressions: {
        hide: '!model.hasInstallments',
      },
      props: {
        label: 'Select Invoice',
        placeholer: 'select invoice',
        valueProp: 'id',
        labelProp: 'label',
        options: [
          { value: 'Item 1', label: 'Item 1' },
          { value: 'Item 2', label: 'Item 2' },
        ],
        required: true,
        singleSelection: true,
        description: 'sends invoice to send to the selected individual',
      },
    },
    {
      key: 'amount',
      type: 'input',
      // hideExpression: 'model.hasInstallments',
      expressions: {
        hide: 'model.hasInstallments',
      },
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Amount',
        placeholder: 'amount of transaction',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: true,
      },
    },
    {
      key: 'note',
      type: 'textarea',
      props: {
        label: 'Notes',
        placeholder: 'Add notes to display to payee here',
        rows: 3,
        required: false,
      },
    },
  ];

  /** Dynamic FundsTransfer Fields*/
  static FundsTransfer: FormlyFieldConfig[] = [
    //not readonly because they need to be modified, at times
    {
      key: 'debitId',
      type: 'select',
      props: {
        label: 'Withdraw From',
        placeholder: 'source of funds',
        options: [],
        valueProp: 'id',
        labelProp: 'label',
        required: true,
        description: 'The account or budget to transfer to...',
      },
    },
    {
      key: 'creditId',
      type: 'select',
      props: {
        label: 'Deposit To',
        placeholder: 'destination account',
        options: [],
        valueProp: 'id',
        labelProp: 'label',
        required: true,
        description: 'The account or budget to deposit to...',
      },
    },
    {
      key: 'amount',
      type: 'input',
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Amount',
        placeholder: 'amount of transaction',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: true,
      },
    },
    {
      key: 'note',
      type: 'textarea',
      props: {
        label: 'Memo',
        placeholder: 'Add payment request notes here',
        rows: 3,
        required: false,
      },
    },
  ];

  /** Dynamic FundsTransfer Fields*/
  static Receipt: FormlyFieldConfig[] = [
    //not readonly because they need to be modified, at times
    {
      key: 'title',
      type: 'input',
      props: {
        label: 'Title',
        placeholder: 'description',
        required: true,
      },
    },
    {
      key: 'memberId', //Change to AutoComplete
      type: 'autocomplete',
      props: {
        label: 'Select Member',
        placeholer: 'search for member',
        options: [
          { value: 'Item 1', label: 'Item 1' },
          { value: 'Item 2', label: 'Item 2' },
        ],
        required: false,
        description: 'sends electronic receipt to the selected individual',
      },
    },
    {
      key: 'transactionDate',
      type: 'datepicker',
      defaultValue: new Date(),

      props: {
        maxDate: new Date().setHours(23, 59, 59, 999),
        max: new Date().setHours(23, 59, 59, 999),
        label: 'Transaction Date',
        placeholder: 'mm-dd-yyyy',
        required: true,
      },
    },
    {
      key: 'amount',
      type: 'input',
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Amount',
        placeholder: 'amount received',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: true,
      },
    },
    {
      key: 'fees.platform',
      type: 'input',
      props: {
        addonLeft: {
          class: 'icon-credit-card',
        },
        label: 'Fees',
        placeholder: 'fees associated with transaction',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: false,
      },
    },
    {
      key: 'account',
      type: 'tags',
      props: {
        label: 'Account',
        placeholder: 'account to credit',
        valueProp: 'id',
        labelProp: 'label',
        options: [],
        required: false,
        singleSelection: true,
      },
    },
    {
      key: 'budget',
      type: 'tags',
      props: {
        label: 'Budget Category',
        placeholder: 'budget category',
        valueProp: 'id',
        labelProp: 'item',
        options: [],
        required: false,
        singleSelection: true,
      },
    },
    {
      key: 'isDonation',
      type: 'toggle',
      defaultValue: false,
      props: {
        label: 'Donation?',
        placeholder: 'donation',
        required: false,
      },
    },
    {
      key: 'donationCost',
      type: 'input',
      expressions: {
        hide: '!model.isDonation',
      },
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Donation Cost',
        placeholder: 'Non-charitable portion of donation',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: false,
      },
    },
    {
      key: 'note',
      type: 'textarea',
      props: {
        label: 'Notes',
        placeholder: 'add notes here',
        rows: 3,
        required: false,
      },
    },
  ];

  /** Dynamic Expense Form Fields*/
  static Expense: FormlyFieldConfig[] = [
    {
      key: 'title',
      type: 'input',
      props: {
        label: 'Title',
        placeholder: 'description',
        required: true,
      },
    },
    {
      key: 'transactionDate',
      type: 'datepicker',
      defaultValue: new Date(),
      props: {
        maxDate: new Date().setHours(23, 59, 59, 999),
        max: new Date().setHours(23, 59, 59, 999),
        label: 'Transaction Date',
        placeholder: 'mm-dd-yyyy',
        required: true,
      },
    },
    {
      key: 'amount',
      type: 'input',
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Amount',
        placeholder: 'amount disbursed',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: true,
      },
    },
    {
      key: 'account',
      type: 'tags',
      props: {
        label: 'Account',
        placeholder: 'account to debit',
        valueProp: 'id',
        labelProp: 'label',
        options: [],
        required: true,
        singleSelection: true,
      },
    },
    {
      key: 'checkNumber',
      type: 'input',
      // hideExpression: '!model.account',
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Check #',
        placeholder: 'check #',
        maxLength: 12,
        pattern: '^[0-9]*$',
        required: false,
      },
    },
    {
      key: 'outstanding',
      type: 'toggle',
      // hideExpression: '!model.account',
      props: {
        // addonLeft: {
        //     class: 'icon-wallet',
        // },
        label: 'Is Check Outstanding?',
        placeholder: 'outstanding',
        // maxLength: 12,
        // pattern: '^[0-9]*$',
        required: false,
      },
    },
    {
      key: 'budget',
      type: 'tags',
      props: {
        label: 'Budget Category',
        placeholder: 'budget category',
        valueProp: 'id',
        labelProp: 'item',
        options: [],
        required: false,
        singleSelection: true,
      },
    },

    {
      key: 'note',
      type: 'textarea',
      props: {
        label: 'Notes',
        placeholder: 'Add payment request notes here',
        rows: 3,
        required: false,
      },
    },
  ];

  static SplitExpense: FormlyFieldConfig[] = [
    {
      key: 'title',
      type: 'input',
      props: {
        label: 'Title',
        placeholder: 'description',
        required: true,
      },
    },
    {
      key: 'transactionDate',
      type: 'datepicker',
      defaultValue: new Date(),
      props: {
        maxDate: new Date().setHours(23, 59, 59, 999),
        max: new Date().setHours(23, 59, 59, 999),
        label: 'Transaction Date',
        placeholder: 'mm-dd-yyyy',
        required: true,
      },
    },
    {
      key: 'amount',
      type: 'input',
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Amount',
        placeholder: 'amount disbursed',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: true,
      },
    },
    {
      key: 'checkNumber',
      type: 'input',
      // hideExpression: '!model.account',
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Check #',
        placeholder: 'check #',
        maxLength: 12,
        pattern: '^[0-9]*$',
        required: false,
      },
    },
    {
      key: 'outstanding',
      type: 'toggle',
      // hideExpression: '!model.account',
      props: {
        // addonLeft: {
        //     class: 'icon-wallet',
        // },
        label: 'Is Check Outstanding?',
        placeholder: 'outstanding',
        // maxLength: 12,
        // pattern: '^[0-9]*$',
        required: false,
      },
    },
    {
      key: 'budget',
      type: 'tags',
      props: {
        label: 'Budget Category',
        placeholder: 'budget category',
        valueProp: 'id',
        labelProp: 'item',
        options: [],
        required: false,
        singleSelection: true,
      },
    },

    {
      key: 'note',
      type: 'textarea',
      props: {
        label: 'Notes',
        placeholder: 'Add payment request notes here',
        rows: 3,
        required: false,
      },
    },
  ];
  /** Dynamic Deposit Form Fields*/
  static Deposit: FormlyFieldConfig[] = [
    //not readonly because they need to be modified, at times
    {
      key: 'title',
      type: 'input',
      props: {
        label: 'Title',
        placeholder: 'description',
        required: true,
      },
    },
    // {
    //     key: 'memberId',    //Change to AutoComplete
    //     type: 'autocomplete',
    //     props: {
    //         label: 'Select Member',
    //         placeholer: 'search for member',
    //         options: [{ value: 'Item 1', label: 'Item 1' }, { value: 'Item 2', label: 'Item 2' }],
    //         required: false,
    //         description: 'sends electronic receipt to the selected individual'
    //     }
    // },
    {
      key: 'transactionDate',
      type: 'datepicker',
      defaultValue: new Date(),
      props: {
        maxDate: new Date().setHours(23, 59, 59, 999),
        max: new Date().setHours(23, 59, 59, 999),
        label: 'Transaction Date',
        placeholder: 'mm-dd-yyyy',
        required: true,
      },
    },
    {
      key: 'amount',
      type: 'input',
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Amount',
        placeholder: 'amount received',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: true,
      },
    },
    {
      key: 'fees.platform',
      type: 'input',
      props: {
        addonLeft: {
          class: 'icon-credit-card',
        },
        label: 'Fees',
        placeholder: 'fees associated with transaction',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: false,
      },
    },
    {
      key: 'account',
      type: 'tags',
      props: {
        label: 'Account',
        placeholder: 'account to credit',
        valueProp: 'id',
        labelProp: 'label',
        options: [],
        required: true,
        singleSelection: true,
      },
    },
    {
      key: 'budget',
      type: 'tags',
      props: {
        label: 'Budget Category',
        placeholder: 'budget category',
        valueProp: 'id',
        labelProp: 'item',
        options: [],
        required: false,
        singleSelection: true,
      },
    },
    // {
    //     key: 'tags',
    //     type: 'tags',
    //     props: {
    //         options: [{value: 'Item 1', label: 'Item 1'}, {value: 'Item 2', label: 'Item 2'}],
    //         valueProp: 'value',
    //         labelProp: 'label',
    //         label: 'Tag',
    //         placeholder: 'select tag',
    //         required: true,
    //         singleSelection: false,
    //     }
    // },
    {
      key: 'note',
      type: 'textarea',
      props: {
        label: 'Notes',
        placeholder: 'add notes here',
        rows: 3,
        required: false,
      },
    },
  ];
  static SplitDeposit: FormlyFieldConfig[] = [
    //not readonly because they need to be modified, at times
    {
      key: 'title',
      type: 'input',
      props: {
        label: 'Title',
        placeholder: 'description',
        required: true,
      },
    },
    {
      key: 'transactionDate',
      type: 'datepicker',
      defaultValue: new Date(),
      props: {
        maxDate: new Date().setHours(23, 59, 59, 999),
        max: new Date().setHours(23, 59, 59, 999),
        label: 'Transaction Date',
        placeholder: 'mm-dd-yyyy',
        required: true,
      },
    },
    {
      key: 'amount',
      type: 'input',
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Amount',
        placeholder: 'amount received',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: true,
      },
    },
    {
      key: 'fees.platform',
      type: 'input',
      props: {
        addonLeft: {
          class: 'icon-credit-card',
        },
        label: 'Fees',
        placeholder: 'fees associated with transaction',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: false,
      },
    },
    {
      key: 'budget',
      type: 'tags',
      props: {
        label: 'Budget Category',
        placeholder: 'budget category',
        valueProp: 'id',
        labelProp: 'item',
        options: [],
        required: false,
        singleSelection: true,
      },
    },
    // {
    //     key: 'tags',
    //     type: 'tags',
    //     props: {
    //         options: [{value: 'Item 1', label: 'Item 1'}, {value: 'Item 2', label: 'Item 2'}],
    //         valueProp: 'value',
    //         labelProp: 'label',
    //         label: 'Tag',
    //         placeholder: 'select tag',
    //         required: true,
    //         singleSelection: false,
    //     }
    // },
    {
      key: 'note',
      type: 'textarea',
      props: {
        label: 'Notes',
        placeholder: 'add notes here',
        rows: 3,
        required: false,
      },
    },
  ];
  /** Dynamic Transfer Form Fields*/
  static Transfer: FormlyFieldConfig[] = [
    //not readonly because they need to be modified, at times
    {
      key: 'fromAccount',
      type: 'select',
      props: {
        label: 'Withdraw From',
        placeholder: 'source of funds',
        options: [
          { value: 'Item 1', label: 'Item 1' },
          { value: 'Item 2', label: 'Item 2' },
        ],
        required: true,
        description: 'The account or budget to transfer to...',
      },
    },
    {
      key: 'toAccount',
      type: 'select',
      props: {
        label: 'Deposit To',
        placeholder: 'destination account',
        options: [
          { value: 'Item 1', label: 'Item 1' },
          { value: 'Item 2', label: 'Item 2' },
        ],
        required: true,
        description: 'destination account',
      },
    },
    {
      key: 'amount',
      type: 'input',
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Amount',
        placeholder: 'amount of transaction',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: true,
      },
    },
    {
      key: 'note',
      type: 'textarea',
      props: {
        label: 'Memo',
        placeholder: 'Add payment request notes here',
        rows: 3,
        required: false,
      },
    },
  ];

  static Complete: FormlyFieldConfig[] = [
    {
      key: 'title',
      type: 'input',
      props: {
        label: 'Title',
        // placeholder: 'description',
        // required: false
      },
    },
    {
      key: 'amount',
      type: 'label',
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Amount',
        // placeholder: 'amount received',
        // pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$',
        // required: false
      },
    },
    {
      key: 'fees.platform',
      type: 'input',
      props: {
        addonLeft: {
          class: 'icon-credit-card',
        },
        label: 'Fees',
        placeholder: 'fees associated with transaction',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        required: false,
      },
    },
    {
      key: 'accountLabel',
      type: 'label',
      props: {
        // addonLeft: {
        //     class: 'icon-wallet',
        // },
        label: 'Account',
        // placeholder: 'amount received',
        // pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$',
        // required: false
      },
    },
    {
      key: 'account',
      type: 'tags',
      props: {
        label: 'Account',
        placeholder: 'account to debit',
        valueProp: 'id',
        labelProp: 'label',
        options: [],
        required: false,
        singleSelection: true,
      },
    },
    {
      key: 'transactionDate',
      type: 'datepicker',
      defaultValue: new Date(),
      props: {
        maxDate: new Date().setHours(23, 59, 59, 999),
        max: new Date().setHours(23, 59, 59, 999),
        label: 'Transaction Date',
        placeholder: 'mm-dd-yyyy',
        required: true,
      },
    },
    {
      key: 'checkNumber',
      type: 'input',
      // hideExpression: '!model.account',
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Check #',
        placeholder: 'check #',
        maxLength: 12,
        pattern: '^[0-9]*$',
        required: false,
      },
    },
    {
      key: 'checkNumberLabel',
      type: 'label',
      props: {
        // addonLeft: {
        //     class: 'icon-wallet',
        // },
        label: 'Check #',
        // placeholder: 'amount received',
        // pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$',
        // required: false
      },
    },
    {
      key: 'outstanding',
      type: 'toggle',
      // hideExpression: '!model.account',
      props: {
        // addonLeft: {
        //     class: 'icon-wallet',
        // },
        label: 'is Check Outstanding?',
        placeholder: 'outstanding',
        // maxLength: 12,
        // pattern: '^[0-9]*$',
        required: false,
      },
    },
    {
      key: 'budget',
      type: 'tags',
      props: {
        label: 'Budget Category',
        placeholder: 'budget category',
        valueProp: 'id',
        labelProp: 'item',
        options: [],
        required: false,
        singleSelection: true,
      },
    },

    {
      key: 'note',
      type: 'textarea',
      props: {
        label: 'Notes',
        placeholder: 'Add payment request notes here',
        rows: 3,
        required: false,
      },
    },
  ];

  static Product: FormlyFieldConfig[] = [
    // ── Product Information ────────────────────────────────────────────────
    {
      className: 'row col-12 border-radius m-b-15',
      fieldGroupClassName: '',
      fieldGroup: [
        {
          className: 'section-label col-12 p-2 d-flex',
          template: '<strong>Product Information</strong><br/>Basic details about this item',
        },
        {
          fieldGroupClassName: 'row',
          fieldGroup: [
            {
              key: 'name',
              className: 'col-md-6',
              type: 'input',
              props: {
                label: 'Name',
                placeholder: 'product or item',
                required: true,
                description: 'name of invoice item',
              },
            },
            {
              key: 'description',
              className: 'col-md-6',
              type: 'input',
              props: {
                label: 'Description',
                placeholder: 'description',
                required: false,
              },
            },
          ],
        },
        {
          fieldGroupClassName: 'row',
          fieldGroup: [
            {
              key: 'numberAvailable',
              className: 'col-md-6',
              type: 'input',
              props: {
                label: 'Total Number Available (per campaign)',
                placeholder: 'quantity available',
                pattern: '^[0-9]{1,5}$',
                required: false,
                maxLength: 5,
                description: 'Total available quantity in campaign',
              },
            },
            {
              key: 'sortOrder',
              className: 'col-md-6',
              type: 'input',
              props: {
                label: 'Sort Order (Optional)',
                placeholder: 'Sort Order',
                pattern: '^([1-9][0-9]{0,2}|1000|2000)$',
                required: false,
                maxLength: 4,
                description: 'Enter a value from 1 - 1000',
              },
            },
          ],
        },
        {
          fieldGroupClassName: 'row',
          fieldGroup: [
            {
              key: 'amount',
              type: 'input',
              className: 'col-md-6',
              props: {
                addonLeft: {
                  class: 'icon-wallet',
                },
                label: 'Amount',
                placeholder: 'amount of item',
                pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
                maxLength: 9,
                required: true,
              },
            },
            {
              key: 'defaultBudgetId',
              type: 'tags',
              className: 'col-md-6',
              props: {
                label: 'Budget Category',
                placeholder: 'budget category',
                description: 'default budget item for order transactions',
                valueProp: 'id',
                labelProp: 'item',
                options: [],
                required: false,
                singleSelection: true,
              },
            },
            {
              key: 'productGroup',
              type: 'tags',
              className: 'col-md-6',
              props: {
                label: 'Product Group',
                placeholder: 'product group',
                description: 'On the checkout page, items can be group',
                valueProp: 'id',
                labelProp: 'item',
                options: [],
                required: false,
                singleSelection: true,
              },
            },
          ],
        },
      ],
    },
    // ── Ticket Information ─────────────────────────────────────────────────
    {
      className: 'row col-12 border-radius m-b-15',
      fieldGroupClassName: '',
      fieldGroup: [
        {
          className: 'section-label col-12 p-2 d-flex',
          template: '<strong>Ticket Information</strong><br/>Configure ticket creation per order',
        },
        {
          fieldGroupClassName: 'row',
          fieldGroup: [
            {
              key: 'isTicket',
              type: 'toggle',
              className: 'col-md-4',
              defaultValue: false,
              props: {
                toggleLabel: 'Create Ticket',
                click: (field: FormlyFieldConfig, event) => {},
                required: true,
                description: 'Create ticket when this item is purchased?',
              },
            },
            {
              key: 'isAllowMultipleTickets',
              type: 'toggle',
              className: 'col-md-4',
              defaultValue: false,
              expressions: {
                hide: '!model.isTicket',
              },
              props: {
                toggleLabel: 'Allow Multiple Tickets (per order)?',
                click: (field: FormlyFieldConfig, event) => {},
                required: true,
                description:
                  'If this item is a group purchase (e.g. Table of Tickets)',
              },
            },
            {
              key: 'multipleTicketQuantity',
              type: 'input',
              className: 'col-md-4',
              expressions: {
                hide: '!model.isAllowMultipleTickets',
              },
              defaultValue: 1,
              props: {
                label: 'Ticket Quantity (per order)',
                placeholder: 'quantity',
                pattern: '^[0-9][0-9]?[0-9]?$',
                required: false,
                maxLength: 3,
                description: 'Number of Tickets to create.',
              },
            },
          ],
        },
      ],
    },
    // ── Availability ───────────────────────────────────────────────────────
    {
      className: 'row col-12 border-radius m-b-15',
      fieldGroupClassName: '',
      fieldGroup: [
        {
          className: 'section-label col-12 p-2 d-flex',
          template: '<strong>Availability</strong><br/>Limit when this item can be purchased',
        },
        {
          fieldGroupClassName: 'row',
          fieldGroup: [
            {
              key: 'limitAvailability',
              type: 'toggle',
              className: 'col-md-4',
              defaultValue: false,
              props: {
                toggleLabel: 'Limit Availability By Date?',
                placeholder: 'Limit availability to date range',
                description: 'Limit availability to date range',
              },
            },
            {
              key: 'availabilityStart',
              type: 'datepicker',
              className: 'col-md-4',
              expressions: {
                hide: '!model.limitAvailability',
              },
              props: {
                minDate: new Date().setHours(23, 59, 59, 999),
                min: new Date().setHours(23, 59, 59, 999),
                label: 'Available Start Date',
                placeholder: 'mm-dd-yyyy',
              },
            },
            {
              key: 'availabilityEnd',
              className: 'col-md-4',
              type: 'datepicker',
              expressions: {
                hide: '!model.limitAvailability',
              },
              props: {
                minDate: new Date().setHours(23, 59, 59, 999),
                min: new Date().setHours(23, 59, 59, 999),
                label: 'Available End Date',
                placeholder: 'mm-dd-yyyy',
              },
            },
          ],
        },
      ],
    },
    // ── Subscription ───────────────────────────────────────────────────────
    {
      className: 'row col-12 border-radius m-b-15',
      fieldGroupClassName: '',
      fieldGroup: [
        {
          className: 'section-label col-12 p-2 d-flex',
          template: '<strong>Subscription</strong><br/>Configure recurring payment schedule',
        },
        {
          fieldGroupClassName: 'row',
          fieldGroup: [
            {
              key: 'isInstallment',
              type: 'toggle',
              className: 'col-md-4',
              props: {
                toggleLabel: 'Is Subscription?',
                placeholder: 'Is subscription?',
                required: true,
                description: 'Has more than one payment?',
                change: (field, $event) => {
                  setTimeout(() => {
                    const isInstallment = field.formControl.value;
                    if (!isInstallment) return;

                    const intervalField = FormUtilities.findFieldByKey(
                      field.parent.fieldGroup,
                      'interval'
                    );
                    const intervalCountField = FormUtilities.findFieldByKey(
                      field.parent.fieldGroup,
                      'intervalCount'
                    );

                    if (intervalField && intervalCountField) {
                      intervalCountField.props.options =
                        TransactionForms.getIntervalOptions(
                          intervalField.formControl.value
                        ).map((s) => {
                          return { label: s, value: s, id: s };
                        });

                      intervalCountField.props.description = `Pay every  x  ${intervalField.formControl.value}s`;
                    }
                  });
                },
              },
            },
            {
              key: 'interval',
              type: 'select',
              className: 'col-md-4',
              expressions: {
                hide: '!model.isInstallment',
              },
              props: {
                label: 'Subscription Interval',
                options: [
                  { label: 'Annual', value: 'year' },
                  { label: 'Daily', value: 'day' },
                  { label: 'Monthly', value: 'month' },
                  { label: 'Weekly', value: 'week' },
                ],
                placeholder: '--',
                required: true,
                description: 'installment payment interval',
                change: (field, $event) => {
                  setTimeout(() => {
                    const intervalCountField = field.parent.fieldGroup.find(
                      (a) => a.key === 'intervalCount'
                    );

                    if (intervalCountField) {
                      const interval = field.formControl.value;
                      intervalCountField.props.options =
                        TransactionForms.getIntervalOptions(interval).map((s) => {
                          return { label: s, value: s, id: s };
                        });
                    }
                    intervalCountField.props.description = `Pay every  x  ${field.formControl.value}s`;
                  });
                },
              },
            },
            {
              key: 'intervalCount',
              type: 'select',
              className: 'col-md-4',
              expressions: {
                hide: '!model.isInstallment ||  model.interval === "year"',
                'props.disabled': (field) => {
                  const { model } = field;
                  return !model.interval;
                },
              },
              props: {
                options: [1, 2, 3, 4, 6, 12],
                label: 'Subscription Period',
                required: true,
                description: 'Installments are paid every x  interval',
              },
            },
          ],
        },
        {
          key: 'numberOfInstallments',
          type: 'input',
          expressions: {
            hide: '!model.isInstallment',
          },
          className: 'col-md-6',
          props: {
            label: 'Fixed Number of Installments',
            placeholder: 'maximum number of payments',
            pattern: '^([1-9]|1[012])$',
            required: false,
            description: 'Fixed numbers of payments.  Leave blank, if on-going.',
          },
        },
        {
          fieldGroupClassName: 'row',
          fieldGroup: [
            {
              key: 'isShowQuantity',
              type: 'toggle',
              className: 'col-md-6',
              defaultValue: false,
              props: {
                toggleLabel: 'Show Quantity?',
                placeholder: 'Allow quantity selection',
                required: true,
                description: 'Allow ability to select quantity',
              },
            },
            {
              key: 'maxQuantity',
              type: 'input',
              className: 'col-md-6',
              expressions: {
                hide: '!model.isShowQuantity',
              },
              defaultValue: 1,
              props: {
                label: 'Maximum Quantity',
                placeholder: 'quantity',
                pattern: '^[0-9][0-9]?[0-9]?$',
                required: false,
                maxLength: 3,
                description: 'Number between 1 and 999',
              },
            },
          ],
        },
      ],
    },
    // ── Budget Recognition ─────────────────────────────────────────────────
    {
      className: 'row col-12 border-radius m-b-15',
      fieldGroupClassName: '',
      fieldGroup: [
        {
          className: 'section-label col-12 p-2 d-flex',
          template: '<strong>Budget Recognition</strong><br/>Control when revenue is recognized in budget reports',
        },
        {
          fieldGroupClassName: 'row',
          fieldGroup: [
            {
              key: 'productType',
              type: 'select',
              className: 'col-md-4',
              defaultValue: 'other',
              props: {
                label: 'Product Type',
                required: false,
                description: 'Classifies the product for budget recognition rules.',
                options: [
                  { label: 'Dues', value: 'dues' },
                  { label: 'Event', value: 'event' },
                  { label: 'Add-On', value: 'addon' },
                  { label: 'Donation', value: 'donation' },
                  { label: 'Subscription', value: 'subscription' },
                  { label: 'Other', value: 'other' },
                ],
              },
            },
            {
              key: 'budgetRecognitionTiming',
              type: 'select',
              className: 'col-md-4',
              defaultValue: 'immediate',
              expressions: {
                hide: "model.productType !== 'dues'",
              },
              props: {
                label: 'Budget Recognition Timing',
                required: false,
                description:
                  'Immediate: recognize on payment date. Term-Deferred: defer to the start of the budget term (prepaid dues).',
                options: [
                  { label: 'Immediate', value: 'immediate' },
                  { label: 'Term-Deferred (prepaid dues)', value: 'term-deferred' },
                ],
              },
            },
            {
              key: 'termId',
              type: 'tags',
              className: 'col-md-4',
              expressions: {
                hide: "model.productType !== 'dues' || model.budgetRecognitionTiming !== 'term-deferred'",
              },
              props: {
                label: 'Budget Term',
                placeholder: 'select term',
                description:
                  'The budget term this dues product is sold for. Recognition defers to the term start date.',
                valueProp: 'id',
                labelProp: 'name',
                options: [],
                required: false,
                singleSelection: true,
              },
            },
          ],
        },
      ],
    },
  ];

  static ACHTransaction: FormlyFieldConfig[] = [
    {
      key: 'title',
      type: 'input',
      props: {
        label: 'Title',
        placeholder: 'description',
        required: true,
      },
    },
    {
      key: 'vendorId', //Change to VendorId List
      type: 'tags',
      props: {
        label: 'Vendor',
        placeholer: 'search for vendor',
        valueProp: 'id',
        labelProp: 'name',
        options: [
          { value: 'Item 1', label: 'Item 1' },
          { value: 'Item 2', label: 'Item 2' },
        ],
        required: false,
        description: 'sends electronic payment to the selected vendor',
        singleSelection: true,
      },
    },
    {
      key: 'amount',
      type: 'input',
      // hideExpression: 'model.hasInstallments',
      expressions: {
        hide: 'model.hasInstallments',
      },
      modelOptions: {
        updateOn: 'change',
      },
      props: {
        addonLeft: {
          class: 'icon-wallet',
        },
        label: 'Amount',
        placeholder: 'amount of transaction',
        pattern: '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]{2})?$',
        maxLength: 9,
        required: true,
      },
    },
    {
      key: 'fees', //achDebitId
      type: 'label',
      props: {
        label: 'Convenience Fee',
        placeholder: 'source of funds',
        onchanges: (c) => {
          // console.log('onChanges c', c);
        },
      },
      expressions: {
        'model.fees': (field: FormlyFieldConfig) => {
          const model = field.model;
          return TransactionForms.calculateFees(model.amount);
        },
      },
    },
    {
      key: 'achAccountId', //achDebitId
      type: 'tags',
      props: {
        label: 'Payment Account',
        placeholder: 'source of funds',
        options: [],
        valueProp: 'id',
        labelProp: 'label',
        required: true,
        description: 'The account to debit',
        singleSelection: true,
      },
    },
    {
      key: 'budget',
      type: 'tags',
      props: {
        label: 'Budget Category',
        placeholder: 'budget category',
        valueProp: 'id',
        labelProp: 'item',
        options: [],
        required: false,
        singleSelection: true,
      },
    },
    {
      key: 'note',
      type: 'textarea',
      props: {
        label: 'Notes',
        placeholder: 'Add notes to display to payee here',
        rows: 3,
        required: false,
        maxLength: 2000,
      },
    },
  ];

  static ImportType: FormlyFieldConfig[] = [
    {
      key: 'title',
      type: 'input',
      props: {
        label: 'Import Type',
        placeholder: 'import type name',
        required: true,
      },
    },
  ];

  static SendReceipt: FormlyFieldConfig[] = [
    {
      key: 'memberId', //Change to AutoComplete
      type: 'autocomplete',
      props: {
        label: 'Select Member',
        placeholer: 'search for member',
        options: [
          { value: 'Item 1', label: 'Item 1' },
          { value: 'Item 2', label: 'Item 2' },
        ],
        required: false,
        description:
          'sends electronic receipt and credits the selected individual with payment',
      },
    },
  ];

  static AssignBudget: FormlyFieldConfig[] = [
    {
      key: 'budget',
      type: 'tags',
      props: {
        label: 'Budget Category',
        placeholder: 'budget category',
        valueProp: 'id',
        labelProp: 'item',
        options: [],
        required: true,
        singleSelection: true,
      },
    },
  ];

  /** Record a Stripe payment duesPlus never saved (deposit detail page). */
  static RecordStripePayment: FormlyFieldConfig[] = [
    {
      key: 'campaignId',
      type: 'select',
      props: {
        label: 'Campaign',
        placeholder: 'None — record as a receipt',
        description: 'The campaign this payment was for, if any.',
        options: [],
      },
    },
    {
      fieldGroupClassName: 'row',
      expressions: { hide: '!model.campaignId' },
      fieldGroup: [
        {
          key: 'productId',
          type: 'select',
          className: 'col-md-8',
          props: {
            label: 'Item',
            placeholder: 'Select an item',
            options: [],
          },
          expressions: { 'props.required': '!!model.campaignId' },
        },
        {
          key: 'quantity',
          type: 'input',
          className: 'col-md-4',
          defaultValue: 1,
          props: {
            type: 'number',
            label: 'Quantity',
            min: 1,
          },
          expressions: { 'props.required': '!!model.campaignId' },
        },
      ],
    },
    {
      key: 'budgetItemId',
      type: 'select',
      props: {
        label: 'Budget Category',
        placeholder: 'Leave unassigned',
        options: [],
      },
    },
    {
      key: 'title',
      type: 'input',
      props: {
        label: 'Title',
        placeholder: 'e.g. Thanksgiving Food Drive 2026',
        required: true,
        maxLength: 200,
      },
    },
    {
      key: 'note',
      type: 'textarea',
      props: {
        label: 'Note',
        placeholder: 'Why this payment is being recorded manually (optional)',
        rows: 2,
        maxLength: 500,
      },
    },
  ];

  static TransferTicket: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          key: 'firstname',
          className: 'col-md-6',
          type: 'input',
          props: {
            addonLeft: {
              class: 'icon-user',
            },
            label: 'First name',
            placeholder: 'first name',
            required: true,
          },
        },
        {
          key: 'lastname',
          type: 'input',
          className: 'col-md-6',
          props: {
            addonLeft: {
              class: 'icon-user',
            },
            label: 'Last name',
            placeholder: 'last name',
            required: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          key: 'email',
          type: 'input',
          className: 'col-6',
          props: {
            addonLeft: {
              class: 'icon-envelope-open',
            },
            placeholder: 'abc@myorganization.com',
            pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$',
            required: true,
            label: 'E-mail',
            maxLength: 60,
          },
        },
        {
          key: 'phone',
          type: 'input',
          className: 'col-6',
          props: {
            addonLeft: {
              class: 'icon-screen-smartphone',
            },
            placeholder: '(###) ###-####',
            required: false,
            maxLength: 20,
            label: 'Phone',
            description: 'Tickets will be sent via text to the number provided',
          },
        },
      ],
    },
  ];

  static ManualTicket: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          key: 'email',
          type: 'input',
          className: 'col-6',
          props: {
            addonLeft: {
              class: 'icon-envelope-open',
            },
            keydown: (event: FormlyFieldConfig, key: KeyboardEvent) => {
              if (event.formControl?.value)
                event.formControl.setValue(
                  event.formControl.value.replace(/\s/g, '').toLowerCase()
                );
            },
            placeholder: 'abc@myorganization.com',
            pattern: '[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$',
            required: true,
            label: 'E-mail',
            maxLength: 60,
            description: 'E-mail for tickets',
          },
        },
        {
          key: 'phone',
          type: 'input',
          className: 'col-6',
          props: {
            addonLeft: {
              class: 'icon-screen-smartphone',
            },
            placeholder: '(###) ###-####',
            required: false,
            maxLength: 20,
            label: 'Phone',
            description: 'Phone number for tickets',
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        // {
        //   key: 'firstname',
        //   className: 'col-md-6',
        //   type: 'input',
        //   props: {
        //     addonLeft: {
        //       class: 'icon-user',
        //     },
        //     label: 'First name',
        //     placeholder: 'first name',
        //     required: true,
        //   },
        // },
        // {
        //   key: 'lastname',
        //   type: 'input',
        //   className: 'col-md-6',
        //   props: {
        //     addonLeft: {
        //       class: 'icon-user',
        //     },
        //     label: 'Last name',
        //     placeholder: 'last name',
        //     required: true,
        //   },
        // },
        {
          key: 'products',
          className: 'col-6',
          type: 'tags',
          props: {
            label: 'Ticket Item',
            placeholder: 'item',
            valueProp: 'id',
            labelProp: 'label',
            options: [],
            required: true,
            singleSelection: true,
          },
        },
        {
          key: 'quantity',
          type: 'input',
          defaultValue: 1,
          className: 'col-6',
          props: {
            label: 'Quantity',
            placeholder: 'quantity',
            pattern: '^[0-9]?[0-9]?$',
            required: true,
            maxLength: 2,
            description: 'Number between 1 and 99',
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          key: 'isPromo',
          type: 'toggle',
          className: 'col-6',
          defaultValue: false,
          props: {
            // addonLeft: {
            //     class: 'icon-wallet',
            // },
            label: 'Complimentary Tickets?',
            // required: true
          },
        },
        {
          key: 'accountId',
          type: 'select',
          className: 'col-6',
          props: {
            label: 'Deposit to',
            placeholder: 'deposit account',
            options: [],
            valueProp: 'id',
            labelProp: 'label',
            required: false,
            description: 'Deposit monies to...',
          },
        },
        {
          key: 'amount',
          type: 'label',
          className: 'col-6',
          defaultValue: 0,
          // hideExpression: false,
          expressions: {
            'model.amount': (field: FormlyFieldConfig) => {
              const model = field.model;
              const regex = /\$(.*?)\)$/;
              const match =
                model.products && model.products.length > 0
                  ? model.products[0].label.match(regex)[1]
                  : '0';
              model['itemPrice'] = match;
              return model.isPromo ? 0 : model.quantity * parseFloat(match); // TransactionForms.calculateFees(model.amount);
            },
          },
          // hideExpression: 'model.hasInstallments',
          props: {
            addonLeft: {
              class: 'icon-wallet',
            },
            label: 'Amount',
            // required: true
          },
        },
      ],
    },
  ];

  static TagField: FormlyFieldConfig[] = [
    // {
    //   fieldGroupClassName: 'row',
    //   fieldGroup: [
    {
      key: 'tags',
      type: 'tags',
      className: 'col-12',
      props: {
        label: 'Tags',
        placeholer: 'add tags',
        valueProp: 'id',
        labelProp: 'label',
        options: [],
        required: false,
      },
    },
    //   ],
    // },
  ];

  static calculateFees(amount): string {
    if (!amount) return '--';
    const duesTrackerFee = ConvenienceFeeService.calculateDuesTrackerFee(
      Number(amount)
    );

    amount = Number(amount);
    let totalWithFees = (
      (Math.round(amount * 100) / 100 + duesTrackerFee) /
      (1 - 0.008)
    ).toFixed(2);

    if (Number(totalWithFees) - amount > 6.5) totalWithFees = amount + 6.5;
    return ((Number(totalWithFees) * 100) / 100 - amount).toFixed(2);
  }

  static getIntervalOptions(interval: string): number[] {
    switch (interval) {
      case 'year':
        return [1];
      case 'day':
        return Array(30)
          .fill(0)
          .map((_, i) => i + 1);
      case 'week':
        return Array(52)
          .fill(0)
          .map((_, i) => i + 1);
      case 'month':
      default:
        return [1, 2, 3, 4, 6, 12];
      // Array(12)
      //   .fill(0)
      //   .map((_, i) => i + 1);
    }
  }
}
